export const it = {
  stepButtons: {
    goBack: "Indietro",
    goForward: "Avanti",
  },
};
